<template>
  <component
    v-if="item.type === ItemType.Html"
    :is="ComponentByType[item.type]"
    :item="templateItem"
  />

  <iframe
    ref="iframeRef"
    :title="item.id"
    v-else
    :srcdoc="templateHtmlFormatted"
    frameborder="0"
    width="100%"
  />
  <!-- <iframe ref="iframeRef" v-else :srcdoc="templateHtml" frameborder="0" width="100%" /> -->
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from "vue";
import { useRender } from "vue-email";

import {
  HtmlItem as HtmlItemType,
  ItemType,
  ItemTypeMapper,
  TemplateItem,
} from "@/@types/flows/emailTemplates/items";
import { TemplateItemsManager } from "@/app/flows/emailTemplates/utils/TemplateItemsManager";

import FooterItem from "@/app/flows/emailTemplates/components/sections/TemplateItem/items/FooterItem.vue";
import HtmlItem from "@/app/flows/emailTemplates/components/sections/TemplateItem/items/HtmlItem.vue";
import TextItem from "@/app/flows/emailTemplates/components/sections/TemplateItem/items/TextItem.vue";
import ImageItem from "@/app/flows/emailTemplates/components/sections/TemplateItem/items/ImageItem.vue";
import ButtonItem from "@/app/flows/emailTemplates/components/sections/TemplateItem/items/ButtonItem.vue";
import { TemplateHtmlBuilder } from "@/app/flows/emailTemplates/utils/TemplateHtmlBuilder";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ComponentByType: Record<ItemType, any> = {
  [ItemType.Text]: TextItem,
  [ItemType.Image]: ImageItem,
  [ItemType.Button]: ButtonItem,
  [ItemType.Html]: HtmlItem,
  [ItemType.Footer]: FooterItem,
};

const props = defineProps<{ item: TemplateItem }>();
const emit = defineEmits<{ htmlStringEdited: [] }>();

const templateItem = computed(() => {
  let item = props.item as ItemTypeMapper[ItemType];
  if (item?.type == ItemType.Html)
    item.content = TemplateHtmlBuilder.generateHtmlLinks(item.content);
  return item;
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const iframeRef = ref<any>();
const templateHtml = ref("");

const templateHtmlFormatted = computed(() => {
  return templateHtml.value.replace(
    /<a((?:(?!target=)[^>])*)href="([^"]*)"(?:(?!target=)[^>]*)>/gi,
    '<a$1href="$2" target="_blank">'
  );
});

onMounted(async () => {
  const renderedComponent = await useRender(ComponentByType[props.item.type], {
    props: { item: templateItem.value },
  });

  const htmlString = renderedComponent.html;

  templateHtml.value = htmlString;
  const parsedHtmlString = TemplateHtmlBuilder.generateHtmlString(
    templateItem.value.type === ItemType.Html
      ? TemplateHtmlBuilder.inlineCssStyles((templateItem.value as HtmlItemType).content)
      : htmlString
  );
  TemplateItemsManager.editElement(templateItem.value.id, { htmlString: parsedHtmlString });
  emit("htmlStringEdited");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const iframe = document.querySelector("#template-item-html-frame") as any;

  iframeRef.value.onload = function () {
    setTimeout(() => {
      const iframeDocument = iframeRef.value.contentWindow.document;

      const height =
        iframeDocument.body.clientHeight < 150
          ? iframeDocument.body.clientHeight
          : iframeDocument.documentElement.scrollHeight;

      iframeRef.value.style.height = `${height}px`;
    }, 0);
  };
});
</script>

<style scoped lang="sass">
iframe
  border: none
  margin: 0
  padding: 0
  min-height: 0
</style>
